import type { ImageResponsePagedData } from '@on3/api';
import { PhotoDialog } from 'components/PhotoDialog/PhotoDialog';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';

import styles from './PhotosThumbnailList.module.scss';

export interface IPhotosThumbnailListProps {
  playerImages?: ImageResponsePagedData;
  numberOfPhotos?: number;
  className?: string;
}

export const PhotosThumbnailList = ({
  playerImages,
  numberOfPhotos = 25,
  className,
}: IPhotosThumbnailListProps) => {
  const { query } = useRouter();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startingModalIndex, setStartingModalIndex] = useState(0);

  const handleModalOpen = (index: number) => {
    setStartingModalIndex(index);
    setIsModalOpen(true);
  };
  const handleModalClose = () => setIsModalOpen(false);

  const photoList = useMemo(
    () => (playerImages?.list ?? []).slice(0, numberOfPhotos),
    [playerImages, numberOfPhotos],
  );

  const showViewAll = photoList.length < (playerImages?.list ?? []).length;
  const viewAllRoute = `/db/${query.id}/photos/`;

  return (
    <>
      <div className={styles.block}>
        <ul className={className}>
          {photoList.map(({ key, source, domain, altText }, index) => (
            <li key={key}>
              <button onClick={() => handleModalOpen(index)} type="button">
                <img
                  alt={altText || ''}
                  className={styles.headshot}
                  src={`https://${domain}/cdn-cgi/image/height=150,width=200,quality=90,gravity=auto${source}`}
                />
              </button>
            </li>
          ))}
        </ul>

        {showViewAll && (
          <footer className={styles.footer}>
            <Link href={viewAllRoute}>View All</Link>
          </footer>
        )}
      </div>

      <PhotoDialog
        onClose={handleModalClose}
        open={isModalOpen}
        photoList={photoList}
        startingModalIndex={startingModalIndex}
      />
    </>
  );
};
